import { allColleges } from "../data/colleges";
import { getCollegeLogoByKey } from "./logoMap";

export const getCollegeInitials = (name) => {
  if (!name) {
    return "TC";
  }

  const compactName = name.replace(/\([^)]*\)/g, "").trim();
  const parts = compactName
    .replace(/\([^)]*\)/g, "")
    .replace(/[^A-Za-z0-9\s.-]/g, "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) {
    return "TC";
  }

  const firstPart = parts[0].replace(/[^A-Za-z0-9]/g, "");
  const isAcronymLike =
    firstPart &&
    firstPart.length <= 4 &&
    firstPart === firstPart.toUpperCase() &&
    /[A-Z]/.test(firstPart);

  if (isAcronymLike) {
    return firstPart;
  }

  if (parts.length === 1) {
    return firstPart.slice(0, 2).toUpperCase();
  }

  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
};

export const getCollegeLogoCandidate = (logoKey) => {
  return getCollegeLogoByKey(logoKey);
};

const normalizeCollegeName = (value = "") =>
  value
    .toLowerCase()
    .replace(/\([^)]*\)/g, "")
    .replace(/[^a-z0-9]/g, "");

const collegeLookup = allColleges.reduce((map, college) => {
  const keys = [college.name, ...(college.sourceAliases || [])];

  keys.forEach((key) => {
    const normalized = normalizeCollegeName(key);
    if (normalized && !map.has(normalized)) {
      map.set(normalized, college);
    }
  });

  return map;
}, new Map());

export const getCollegeByName = (name) => {
  if (!name) {
    return null;
  }

  return collegeLookup.get(normalizeCollegeName(name)) || null;
};

export const getCollegeDisplayName = (name) => {
  const college = getCollegeByName(name);
  return college?.name || name;
};

export const getCollegeStateByName = (name) => {
  const college = getCollegeByName(name);
  return college?.state || "Network College";
};

export const getCollegeLogoByName = (name) => {
  const college = getCollegeByName(name);
  if (!college) {
    return null;
  }

  return getCollegeLogoByKey(college.logoKey);
};
